module.exports = __webpack_public_path__ + "img/introduce3.89a9e0ad.png";